(function () {
  var thumbs = document.querySelectorAll('[data-product-thumb]');
  var mainImg = document.getElementById('ProductMainImageTag');

  function setMainImage(src) {
    if (mainImg && src) mainImg.src = src;
  }

  if (thumbs.length && mainImg) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMainImage(thumb.getAttribute('data-full-src'));
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  var select = document.getElementById('ProductVariantSelect');
  var priceEl = document.getElementById('ProductPrice');
  var submitBtn = document.getElementById('ProductSubmitButton');
  var submitBtnText = document.getElementById('ProductSubmitButtonText');
  if (!select) return;

  var currency = document.body.getAttribute('data-currency') || 'USD';

  function money(cents) {
    return (cents / 100).toLocaleString('fr-TN', { style: 'currency', currency: currency });
  }

  select.addEventListener('change', function () {
    var option = select.options[select.selectedIndex];
    if (!option) return;

    if (priceEl) priceEl.textContent = money(parseInt(option.getAttribute('data-price'), 10));

    var isAvailable = option.getAttribute('data-available') === 'true';
    if (submitBtn) submitBtn.disabled = !isAvailable;
    if (submitBtnText) submitBtnText.textContent = isAvailable ? 'Ajouter au panier' : 'Épuisé';

    var image = option.getAttribute('data-image');
    if (image) setMainImage(image);
  });
})();
